module.exports = __webpack_public_path__ + "static/media/eminence-asakusa-3.807fbb43.jpg";